const api = {
  BASE: 'https://europe-west2-totoconnect.cloudfunctions.net/api',
}
export default api
